import { LoanNavBaseState } from "components/v2/loan-status-chip/loanNavStatusMapping";
import { ApplicationLoanStatus } from "pages/application/applicationService";

/** Maps Encompass `ApplicationLoanStatus` to LogicMatrices §1 base states 0–7. */
export const mapLoanStatusToBaseState = (status: ApplicationLoanStatus): LoanNavBaseState => {
  switch (status) {
    case "new":
      return 0;
    case "started":
      return 1;
    case "incomplete":
      return 2;
    case "submittedToUnderwriting":
      return 3;
    case "processing":
      return 4;
    case "conditionallyApproved":
    case "underReview":
    case "finalReview":
      return 5;
    case "clearedToClosed":
      return 6;
    case "funded":
    case "expired":
      return 7;
  }
};
